import Axios from 'src/services/axios';
import { isNil } from 'lodash';
import { resolvePath } from 'src/cdn';
import { logInfo, toastAndLog } from 'src/services/loggingService';

import { dataURItoBlob, ImageBlobMeta, watermarkBlob } from './WatermarkImage';

import noImagePath from 'src/common-ui/images/noimage.jpg';
import { getCroppedImgFromString } from 'src/components/ImageCropper/ImageCropper/Cropper.utils';
const noImage = resolvePath(noImagePath);

export const uploadImage = async (imgBlob: ImageBlobMeta): Promise<string> => {
  const formData = new FormData();
  formData.append('file', imgBlob.blob);
  formData.append('type', imgBlob.mime);

  try {
    const result = await Axios.post('api/asset/upload', formData);
    const fileName = result.data.data;
    logInfo(`Successfully saved image to server of fileName: ${fileName}`);
    return fileName;
  } catch (e) {
    // not sure why we don't use the actual error `e` here, but I'm keeping the same behavior as before
    const localError = new Error('An error occurred uploading the image. No fileName available yet.');
    toastAndLog(localError.message, e);
    return Promise.reject(localError);
  }
};

export const watermarkAndUpload = async (imgSrc: string): Promise<string> => {
  const croppedImage = await getCroppedImgFromString(imgSrc);
  const watermarkedImage = await watermarkBlob(croppedImage).catch(() => null);

  if (!isNil(watermarkedImage)) {
    try {
      const newImage = dataURItoBlob(watermarkedImage);
      const imageUrl = await uploadImage(newImage);
      if (imageUrl) {
        return imageUrl;
      }
    } catch (_error) {
      // send noImage in case image upload fails
      return noImage;
    }
  }

  return noImage;
};
